import Box from "@mui/material/Box/index.js";
import { styled } from "@mui/material/styles";
const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2)
}));
export {
  Wrapper
};
